import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { BeatLoader } from "react-spinners";
import stripePay from "../../../assets/images/payment/stripe.jpg";

const CheckoutForm = ({ booking }) => {
   const [cardError, setCardError] = useState("");
   const [success, setSuccess] = useState("");
   const [processing, setProcessing] = useState(false);
   const [transactionId, setTransactionId] = useState("");
   const [clientSecret, setClientSecret] = useState("");

   const stripe = useStripe();
   const elements = useElements();
   const { price, buyerName, buyerEmail, _id } = booking;

   useEffect(() => {
      // Create PaymentIntent as soon as the page loads
      fetch("https://recycle-hut-server.vercel.app/create-payment-intent", {
         method: "POST",
         headers: {
            "Content-Type": "application/json",
         },
         body: JSON.stringify({ price }),
      })
         .then((res) => res.json())
         .then((data) => setClientSecret(data.clientSecret));
   }, [price]);

   const handleSubmit = async (event) => {
      event.preventDefault();

      if (!stripe || !elements) {
         return;
      }

      const card = elements.getElement(CardElement);
      if (card === null) {
         return;
      }

      const { error, paymentMethod } = await stripe.createPaymentMethod({
         type: "card",
         card,
      });

      if (error) {
         console.log(error);
         // setCardError(error.message);
         toast.error(error.message);
         setProcessing(false);
      } else {
         setCardError("");
      }
      setSuccess("");

      setProcessing(true);
      const { paymentIntent, error: confirmError } =
         await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
               card: card,
               billing_details: {
                  name: buyerName,
                  email: buyerEmail,
               },
            },
         });

      if (confirmError) {
         // setCardError(confirmError.message);
         // toast.error(confirmError.message)
         setProcessing(false);
         return;
      }
      console.log("paymentIntent:", paymentIntent);

      if (paymentIntent.status === "succeeded") {
         console.log("card info", card);

         // store payment info in the database
         const payment = {
            price,
            transactionId: paymentIntent.id,
            bookingId: _id,
            name: buyerName,
            email: buyerEmail,
         };
         fetch("https://recycle-hut-server.vercel.app/payments", {
            method: "POST",
            headers: {
               "content-type": "application/json",
            },
            body: JSON.stringify(payment),
         })
            .then((res) => res.json())
            .then((data) => {
               console.log(data);

               if (data.insertedId) {
                  setSuccess("Congratulations! your payment is completed");
                  setTransactionId(paymentIntent.id);
               }
            });
      }
      setProcessing(false);
   };

   return (
      <>
         <form onSubmit={handleSubmit} className="">
            <div className="shadow bg-base-50 rounded-lg py-3 pl-3 uncommon">
               <CardElement
                  options={{
                     style: {
                        base: {
                           fontSize: "16px",
                           color: "#424770",
                           "::placeholder": {
                              color: "#aab7c4",
                           },
                        },
                        invalid: {
                           color: "#9e2146",
                        },
                     },
                  }}
               />
            </div>

            <div className="border shadow-sm p-2 rounded-lg text-cente mt-5">
               <p className="text-cyan- text-center">
                  <span className="font-semibold"> Email Address:</span> {buyerEmail}
               </p>
            </div>

            <div className="flex justify-between items-cente mt-7">
               <div className="">
                  <button
                     className="btn btn-sm md:btn-xs lg:btn-sm text-white border-none btn-primary bg-opacity-75 hover:bg-info px-3 py-0 my-transition-9"
                     type="submit"
                     // disabled={!stripe || !clientSecret || processing}
                     disabled={!stripe || !clientSecret}
                  >
                     {processing ? (
                        <BeatLoader color="#fff" size="11" speedMultiplier=".6" />
                     ) : (
                        <>
                           Pay
                           <span className="text-l font-bold mx-1 mb-0">
                              <strong>৳</strong>
                           </span>
                           {price}
                        </>
                     )}
                  </button>
               </div>
               <div className="font-semibol">
                  <img
                     src={stripePay}
                     className="w-[130px] md:w-[110px] lg:w-[170px]"
                     alt="stripe"
                  />
               </div>
            </div>
         </form>
         <p className="text-red-500">{cardError}</p>

         <div>
            {success && (
               <div className="mt-5 text-center">
                  <p className="text-green-500 font-bold mb-1">{success}</p>
                  <p>
                     <span className="font-semibold">Your transactionId is:</span>
                     <span className="font-bold mx-1 text-orange-600">
                        <br />
                        {transactionId}
                     </span>
                     <br />
                     <p className="font-bold mt-1 text-blue-500">The phone will come to you within 24 hours!</p>
                  </p>
               </div>
            )}
         </div>
      </>
   );
   // toast.success(success)
};

export default CheckoutForm;
